import { APP_TYPE } from "../_snowpack/pkg/@topmonks/postcube.js";

export const APP_TYPE_LABEL = {
  [APP_TYPE.MACHINE_2_MACHINE]: "Machine-to-machine",
  [APP_TYPE.SINGLE_PAGE]: "Single page application (web)",
};
